import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ScreeningRecord, ScreeningResult } from "../../models/Interfaces";
import getIzProvider from "../../models/providers/IzProviders";
import "../immunizations/events.css";
import { useTranslation } from "react-i18next";

export default function ScreeningFAQ({ screening }: { screening: ScreeningRecord }) {
  const { t } = useTranslation();
  const provider = screening?.izProviderKey ? getIzProvider(screening.izProviderKey, t) : undefined;
  return (
    <div className="p-4  flex flex-col gap-6">
      <h2 className="font-extrabold text-xl">{t(`screening.lead_info_section_title`)}</h2>
      <div className="">
        <h2 className="font-extrabold text-lg">{t(`screening.lead_info_title_1`)}</h2>
        <ul>
          <li>
            <p>{t(`screening.lead_info_section_1_1`)}</p>
          </li>
        </ul>
        <div className="badge badge-primary dark:badge-neutral mt-2 h-fit">
          {t(`screening.lead_info_section_1_2`)}
        </div>
      </div>

      <div className="">
        <h2 className="font-extrabold text-lg">{t(`screening.lead_info_title_2`)}</h2>
        <ul>
          <li>
            <p>{t(`screening.lead_info_section_2_1`)}</p>
          </li>
        </ul>
        <div className="badge badge-primary dark:badge-neutral mt-2 h-fit">
          {t(`screening.lead_info_section_2_2`)}
        </div>
      </div>

      <div className="">
        <h2 className="font-extrabold text-lg">{t(`screening.lead_info_title_3`)}</h2>
        <ul>
          <li>
            <p>{t(`screening.lead_info_section_3_1`)}</p>
          </li>
          <li>
            <p>{t(`screening.lead_info_section_3_2a`)}</p>
          </li>
        </ul>
        <div className="badge badge-primary dark:badge-neutral mt-2 h-fit">
          {t(`screening.lead_info_section_3_2b`)}
        </div>
      </div>

      <div className="">
        <p>{t(`screening.lead_info_section_footer_1`)}</p>
        <br />
        <p>
          {t(`screening.lead_info_section_footer_2`)}
          {provider && (
            <a href={provider.screeningResultLink} style={{ fontSize: `0.90rem` }}>
              {provider.screeningResultLink}
            </a>
          )}
        </p>
      </div>
    </div>
  );
}
